import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    defaultLocale: String,
    host: String,
    domain: String
  }

  connect() {
    const alternateLocale = document.head.querySelector('meta[name=alternate-locale]').content;
    this.alternateUrl = document.head.querySelector(`meta[name="alternate-url:${alternateLocale}"]`)
    this.alternateHreflang = document.head.querySelector(`link[hreflang=${alternateLocale}-BY`)
    this.alternatePageUrl = ""
    console.log('locales controller connected')
  }

  handleClick(event) {
    event.preventDefault()

    const locale = event.target.dataset.locale
    this.redirectToLocale(locale)
  }

  redirectToLocale(locale) {
    if (this.alternateUrl) {
      this.alternatePageUrl = this.alternateUrl.content
    } else {
      this.alternatePageUrl = this.alternateHreflang.href
    }

    window.location = this.alternatePageUrl
  }
}
